import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';
import mutations from './mutations';
import actions from './actions';
Vue.use(Vuex);

const state = {
  showTestimonials: false,
  showFinalScore: false
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules,
  strict: process.env.NODE_ENV !== 'production'
});



// WEBPACK FOOTER //
// ./src/store/index.js